import "./services/firebase";
import firebase from "./services/firebase";
import React, { useState, useEffect, useContext } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { Link, Switch, BrowserRouter, Route, Redirect } from "react-router-dom";

import { uiConfig } from "./services/firebaseAuth";
import { useStatisticVariables } from "./services/firestore";
import {
  ProductShow,
  Checkout,
  History,
  Favorite,
  PaypalCheckout,
} from "./containers";
import { UserContext } from "./context";
import { Layout, Loading, LoadingSign, PrettyJSON } from "./components";
import ContextProvider from "./ContextProvider";
import { isDev, getPartnerName, getIsSale } from "./helpers";

document.title = getPartnerName() + " Restaurant";
document.getElementsByTagName("head")[0].append(`<meta
name="description"
content="${getPartnerName()} Restaurant Bestellung & Lieferung"
/>`);

export default function App() {
  const { user } = useContext(UserContext);

  const {
    deliverMenu: menu,
    discountCondition,
    deliverCondition,
    locations,
  } = useStatisticVariables();
  const isSale = discountCondition ? getIsSale(discountCondition) : null;
  const isSaleExplaination = discountCondition
    ? discountCondition.explaination
    : null;
  const minDeliverTotal = deliverCondition ? deliverCondition.minTotal : null;
  const freeDeliverDistance = deliverCondition
    ? deliverCondition.freeDistance
    : null;
  const noDeliverExplaination = deliverCondition
    ? deliverCondition.explaination
    : null;

  const [menuPart, setMenuPart] = useState({
    first: "normal",
    second: "Vorspeise",
  });

  return (
    <BrowserRouter>
      {isDev ? console.log("render app") : null}
      <Layout
        setMenuPart={setMenuPart}
        isSale={isSale}
        noSaleExplaination={isSaleExplaination}
      >
        <Switch>
          <Route path="/" exact>
            <Loading toLoad={menu}>
              <ProductShow menu={menu} menuPart={menuPart} />
            </Loading>
          </Route>
          <Route path="/checkout">
            <Checkout
              // minDeliverTotal={minDeliverTotal}
              // noDeliverExplaination={noDeliverExplaination}
              // freeDeliverDistance={freeDeliverDistance}
              deliverCondition={deliverCondition}
              partnerLocations={locations}
            />
          </Route>
          <Route path="/history">
            <History />
          </Route>
          <Route path="/favorite">
            <Loading toLoad={menu}>
              <Favorite menu={menu} favorite={user.favorite} />
            </Loading>
          </Route>
          <Route path="/pay/:orderID">
            <PaypalCheckout />
          </Route>
          <Redirect to="/" />
        </Switch>
      </Layout>
    </BrowserRouter>
  );
}
